/* Edit case */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FaEdit, FaTrash, FaTimes, FaInfoCircle, FaUpload, FaFilePdf, FaFileExcel } from "react-icons/fa";
import "./components/SettlementRateEntries.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Modal from "react-responsive-modal";
import {
	fetch_settlementRates,
	fetch_settlementRate
} from "./redux/actions";
import axios from "axios";
import { apiUri } from "../../config";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import {
	//padCalendar,
	//numberWithCommas,
	allowAlphaNumeric,
	onlyNumeric
} from "../../util";
import DisclosureModal from "./components/DisclosureModal";

import Select from 'react-select';


const state = {
	className: "CaseSelectorEntry"
};

const integerRegrex = /^[0-9]*$/;
const aphabetnumberRegex = /^[a-zA-Z0-9]*$/;

class SettlementRateEntries extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			settlementRateDataArray: [],
			currentSettlementRates: [],
			sortValue: "",
			sortOrder: "",
			SettlementRateData: {},
			className: "CaseSelectorEntry",
			isAdminToken: false,
			open: false,
			fileUploadOpen: false,
			heading: "Update SettlementRate",
			EditSettlementRateData: {},
			EditSettlementRateFile: {},
			openDelete: false,
			viewerModal: false,
			deleteModalData: {},
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			sicCodeError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: "",
			fileUploadError: "",
			enableView: false,
			enableCMView: false,
			enableSettlementRate: false,
			indexList: [],
			SettlementRateInfo: false,
			fileUploadSettlementRateId: false
		};
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleSaveSettlementRate = this.handleSaveSettlementRate.bind(this);
		this.handleFileUpload = this.handleFileUpload.bind(this);
		this.goToCases = this.goToCases.bind(this);
	}

	goToCases(id) {
		sessionStorage.setItem('DANDO',true);
		this.props.history.push("/cases/" + id);
	}
	handleSaveSettlementRate(data) {
		let status = true;
		if (
			!this.state.EditSettlementRateData.companyName ||
			this.state.EditSettlementRateData.companyName.trim() === ""
		) {
			status = false;
			this.setState({
				companyNameError: "Company Name required!"
			});
		} else {
			this.setState({ companyNameError: "" });
		}

		if (
			!this.state.EditSettlementRateData.riskAssessmentDate ||
			this.state.EditSettlementRateData.riskAssessmentDate === ""
		) {
			status = false;
			this.setState({
				riskAssessmentDateError: "Risk Assessment Date required!"
			});
		} else {
			this.setState({ riskAssessmentDateError: "" });
		}

		if (
			!this.state.EditSettlementRateData.ticker ||
			this.state.EditSettlementRateData.ticker.trim() === ""
		) {
			status = false;
			this.setState({
				tickerError: "Ticker required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditSettlementRateData.ticker)) {
				status = false;
				this.setState({
					tickerError: "Enter only alphanumeric characters"
				});
			} else {
			this.setState({ tickerError: "" });
			}
		}

		if (
			!this.state.EditSettlementRateData.identifier ||
			this.state.EditSettlementRateData.identifier.trim() === ""
		) {
			status = false;
			this.setState({
				identifierError: "Identifier required!"
			});
		} else {
			if (!aphabetnumberRegex.test(this.state.EditSettlementRateData.identifier)) {
				status = false;
				this.setState({
					identifierError: "Enter only alphanumeric characters"
				});
			} else {
				this.setState({ identifierError: "" });
			}
		}

		if (
			!this.state.EditSettlementRateData.sicCode ||
			this.state.EditSettlementRateData.sicCode === ""
		) {
			status = false;
			this.setState({
				sicCodeError: "SIC Code required!"
			});
		} else {
			if (!integerRegrex.test(this.state.EditSettlementRateData.sicCode)) {
				status = false;
				this.setState({
					sicCodeError: "Enter only numbers"
				});
			} else {
			this.setState({ sicCodeError: "" });
			}
		}

		if (
			!this.state.enableSettlementRate &&
			(!this.state.EditSettlementRateData.market ||
			this.state.EditSettlementRateData.market.trim() === "")
		) {
			status = false;
			this.setState({
				marketError: "Market required!"
			});
		} else {
			this.setState({ marketError: "" });
		}

		if (
			!this.state.enableSettlementRate &&
			(!this.state.EditSettlementRateData.caseFile ||
			this.state.EditSettlementRateData.caseFile.trim() === "")
		) {
			status = false;
			this.setState({
				caseFileError: "Case File required!"
			});
		} else {
			this.setState({ caseFileError: "" });
		}

		if (
			!this.state.EditSettlementRateData.indexListId ||
			isNaN(this.state.EditSettlementRateData.indexListId)
		) {
			status = false;
			this.setState({
				indexListIdError: "Must Select an industry index!"
			});
		} else {
			this.setState({ indexListIdError: "" });
		}
		
		if (status) {
			this.props.handleSaveFileData(data);
			this.setState({ open: false });
			if (this.state.enableSettlementRate) {
				this.props.fetch_settlementRates(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
			} 
		} else {
			return false;
		}
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.settlementRates) {
			if (this.state.isAdminToken && this.state.routeName === "/settlementRates") {
				this.setState({ enableView: true });
			}
			nextProps.settlementRates.forEach(element => {
				element.enableEdit = false;
				element.riskAssessmentDate_UI = element.riskAssessmentDate;
			});
			this.setState({ settlementRateDataArray: nextProps.settlementRates });
			if (this.state.routeName === "/SettlementRateManagement") {
				this.setState({ enableSettlementRate: true });
			}
			
		}
	};

	componentWillMount() {
		let state = this.state;
		state.settlementRateDataArray = this.props.settlementRates;

		state.settlementRateDataArray.forEach(element => {
			element.enableEdit = false;
			element.riskAssessmentDate_UI = element.riskAssessmentDate;
		});
		state.routeName = window.location.pathname;
		this.setState(state);
		this.setState({ settlementRateDataArray: state.settlementRateDataArray });
	};

	componentDidMount() {
		if (this.state.routeName === "/SettlementRateManagement") {
			this.setState({ enableSettlementRate: true });
			this.getIndexList();
		}
		this.setState({
			isAdminToken:
			localStorage.getItem("isAdminToken") === "false" ? false : true
		});
	};

	handleDelete = settlementRate => {
		let url = "";
		if (this.state.enableSettlementRate) {
			url = "/settlementRate/" + settlementRate.settlementRateId;
		} 
		axios
			.delete(apiUri + url)
			.then(json => {
			if (json.data && json.data.statusCode === 200) {
				if (this.state.enableSettlementRate) {
					this.props.fetch_settlementRates(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
				} 
				NotificationManager.success(json.data.statusMessage, "Success");
				this.setState({ openDelete: false, deleteModalData: {} });
			}
			})
			.catch(err => {
			NotificationManager.error(err);
			console.log(err);
			});
	};

	handleOnChange = (SettlementRateData, value, key) => {
		let state = this.state;
		if (key === "enabled") {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			if (value === "false") {
				state.EditSettlementRateData["enabled"] = true;
			} else {
				state.EditSettlementRateData["enabled"] = false;
			}
		} else if (key === "riskAssessmentDate" ) {
			this.setState({ [key]: value, [key + "Error"]: "" });
			let d = value;
			//d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
			state.EditSettlementRateData[key] = new Date(value).getTime();
			state.EditSettlementRateData[key + "_UI"] =
			new Date(d).getFullYear() +
			"-" +
			("0" + (new Date(d).getMonth() + 1)).slice(-2) +
			"-" +
			("0" + new Date(d).getDate()).slice(-2);
		} else {
			this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
			state.EditSettlementRateData[key] = value;
		}
		this.setState({ EditSettlementRateData: state.EditSettlementRateData });
		if (state.enableSettlementRate) {
			
			
		} else {
			this.props.fetch_settlementRates(
				this.props.currentPage,
				this.state.sortValue,
				this.state.sortOrder
			);
		}

	};

	handleSettlementRateStatusOnChange = (SettlementRateData, value, key) => {
		let state = this.state;
		this.setState({ [value.name]: value.value, [value.name + "Error"]: "" });
		state.EditSettlementRateFile[key] = value;
		this.setState({ EditSettlementRateFile: state.EditSettlementRateFile });

	};

	handleEnable = (SettlementRateData, value, key) => {
		let state = this.state;
		state.settlementRateDataArray.forEach(element => {
			if (state.enableSettlementRate) {
				if (element.settlementRateId === SettlementRateData.settlementRateId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			} else {
				if (element.settlementRateId === SettlementRateData.settlementRateId) {
					if (value === "false") {
						element["enabled"] = true;
					} else {
						element["enabled"] = false;
					}
					this.props.handleSaveStatus(element);
				}
			}
		});
	};

	componentDidCatch(error, errorInfo) {
		console.log("Error:", error, errorInfo);
	}

	handleEdit = (SettlementRateData, value) => {
		let state = this.state;
		state.settlementRateDataArray.forEach(element => {
			if (state.enableSettlementRate) {
				if (element.id === SettlementRateData.id) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			} else {
				if (element.settlementRateId === SettlementRateData.settlementRateId) {
					element.enableEdit = true;
					element.riskAssessmentDate =
						new Date(element.riskAssessmentDate_UI).getTime() +
						new Date(element.riskAssessmentDate_UI).getTimezoneOffset() *
						60 *
						1000;
				}
			}
		});
		this.setState(state);
		this.setState({ EditSettlementRateData: SettlementRateData, open: true });
		
	};

	handleFileUpload = (SettlementRateData, value) => {
		let myExcelFileName = "";
		let myPdfFileName = "";
		if(SettlementRateData && SettlementRateData.excelURL) {
			let excelArr = SettlementRateData.excelURL.split("/");
			excelArr = excelArr[excelArr.length-1].split("?");
			myExcelFileName = excelArr[0];

		}
		if(SettlementRateData && SettlementRateData.pdfURL) {
			let pdfArr = SettlementRateData.pdfURL.split("/");
			pdfArr = pdfArr[pdfArr.length-1].split("?");
			myPdfFileName = pdfArr[0];

		}
		this.setState({ EditSettlementRateFile: SettlementRateData, fileUploadOpen: true, selectedExcelFileName: myExcelFileName, selectedPdfFileName: myPdfFileName });

	};

	handleViewer = (viewerFileURL, viewerFileType) => {

		let myURL = "https://docs.google.com/viewer?url="+encodeURIComponent(viewerFileURL)+"&embedded=true";
		if(viewerFileType === 'xlsx')
			myURL = "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(viewerFileURL);
			

		this.setState({ viewerModal: true, viewerFileUrl: myURL});

	};
	onOpenModal = () => {
		this.setState({ open: true });
	};

	onCloseModal = () => {
		this.setState({ open: false, openDelete: false });
		this.resetErrorStat();
	};

	onCloseUploadModal = () => {
		this.setState({ open: false, fileUploadOpen: false });
		this.resetErrorStat();
	};

	onCloseViewerModal = () => {
		this.setState({ open: false, viewerModal: false });
		this.resetErrorStat();
	};

	onCloseSettlementRateInfoModal = () => {
		this.setState({ SettlementRateInfo: false });
	};

	resetErrorStat = () => {
		this.setState({
			companyNameError: "",
			riskAssessmentDateError: "",
			tickerError: "",
			docketIdError: "",
			sicCodeError: "",
			marketError: "",
			caseFileError: "",
			notesError:"",
			indexListIdError:"",
			identifierError: ""
		});
	};

	handleChange = name => event => {
		this.setState({ ...state, [name]: event.target.checked });
	};

	handleSelectChange = (selectedOption) => {
		let state = this.state;
		this.setState({ "indexListId": selectedOption.value, "indexListIdError": "" });
		state.EditSettlementRateData["indexListId"] = selectedOption.value;
	//var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(selectedOption.value);

	};

	handleInfo = (selectedDando) => {
		
		this.setState({
			SettlementRateInfo: true
		});
		this.setState({ "currentSettlementRate": selectedDando});

	};

	setSelectDefault = (inValue) => {
		var getIndex = this.state.indexList.map(function (options) { return options.value; }).indexOf(inValue);

		return getIndex;
	};

	getIndexList() {
		axios
			.get(apiUri + "/cases/getIndexList")
			.then(res => {
				this.setState({
					indexList: res.data['content']
				});

			})
			.catch(err => {
				console.log(err);
			});
	};

	getamendClaimsList() {
		axios
			.get(apiUri + "/cases/amendClaims")
			.then(res => {
				this.setState({ amendClaimsList: res.data.content });
			})
			.catch(err => {
				console.log(err);
			});
	};

	fetch_settlementRate(id) {
		this.setState({
			SettlementRateInfo: true
		});
		let myResponse = this.props.fetch_settlementRate(id);

		this.setState({currentSettlementRate : myResponse})
	};

	handleOnFileChange(event) { 
		// Update the state 
		if(event.target.name === "excelFile") {
			this.setState({ selectedExcelFile: event.target.files[0] }); 
			this.setState({ selectedExcelFileName: event.target.files[0].name }); 
		} else if (event.target.name === "pdfFile") {
			this.setState({ selectedPdfFile: event.target.files[0] }); 
			this.setState({ selectedPdfFileName: event.target.files[0].name });
		}
	
	};
	 
	// On file upload (click the upload button) 
	handleOnFileUpload(settlementRateId) { 
	
	// Create an object of formData 
		if(this.state.selectedExcelFile) {
			axios
				.get(apiUri + "/settlementRate/" + settlementRateId.settlementRateId + "/upload/xlsx")
				.then(res => {
					this.setState({
						uploadExcelFileName: res.data.data['fileURL']
					});
					
					var axiosUploader = axios.create();
					delete axiosUploader.defaults.headers.common['Authorization'];
					axiosUploader.put(this.state.uploadExcelFileName, this.state.selectedExcelFile)
					.then(res => {
						NotificationManager.success("Excel File Uploaded Successfully", "Success");
					});
				})
				.catch(err => {
					console.log(err);
					NotificationManager.error("Failed to upload file: Excel", "Error");
				});

			this.setState({ fileUploadOpen: false });
		  // Request made to the backend api 
		  // Send formData object 
		}
		if(this.state.selectedPdfFile) {
			axios
				.get(apiUri + "/settlementRate/" + settlementRateId.settlementRateId + "/upload/pdf")
				.then(res => {
					this.setState({
						uploadPdfFileName: res.data.data['fileURL']
					});

					
					var axiosUploader = axios.create();
					delete axiosUploader.defaults.headers.common['Authorization'];
					axiosUploader.put(this.state.uploadPdfFileName, this.state.selectedPdfFile)
					.then(res => {
						NotificationManager.success("PDF File Uploaded Successfully", "Success");
					});
				})
				.catch(err => {
					console.log(err);
					NotificationManager.error("Failed to upload file: PDF", "Error");
				});

			this.setState({ fileUploadOpen: false });
		  // Request made to the backend api 
		  // Send formData object 
		}

		axios.put(apiUri + "/settlementRate/"+ settlementRateId.settlementRateId, {status: this.state.EditSettlementRateFile.status})
		.then(json => {
			this.setState({UpdateSettlementRateResult: json.data});
			
		})
		.catch(err => {
			console.log("Failed to create risk assessment " + err);
			this.setState({error: err.response.data.message});
			NotificationManager.error("Failed to update status", "Error");
		})

	  
	}; 

	render() {
		let props = this.props;
		let state = this.state;
		return (
			<React.Fragment>
				<Modal open={this.state.open} onClose={this.onCloseModal}>
					<div className="ModalWindow modaladd">
					<FaTimes className="closeicon" onClick={this.onCloseModal} />
					<h3 className="modalHeading">{state.heading}</h3>
					<div className="NavDivider"></div>
					<table>
						<thead></thead>
						<tbody>
						<tr>
							<td className="modalTd">
							Risk Name:
							</td>
							<td style={{ paddingTop: 16 }}>
							<input
								id="search"
								type="text"
								className="searchBox2"
								value={state.EditSettlementRateData.companyName || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"companyName"
								);
								}}
							/>
							<span id="error-style">{this.state.companyNameError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Risk Assessment Date</td>
							<td style={{ paddingTop: 16 }}>
							<DatePicker
								className="searchBox2"
								selected={state.EditSettlementRateData.riskAssessmentDate || ""}
								onChange={evt =>
								this.handleOnChange(
									state.EditSettlementRateData,
									evt,
									"riskAssessmentDate"
								)
								}
								dateFormat="yyyy-MM-dd"
							/>
							<span id="error-style">
								{this.state.riskAssessmentDateError}
							</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Ticker</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditSettlementRateData.ticker || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"ticker"
								);
								}}
							/>
							<span id="error-style">{this.state.tickerError}</span>
							</td>
						</tr>
						 <tr>
						 <td className="modalTd">CapIQ Identifier</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => allowAlphaNumeric($event)}
								value={state.EditSettlementRateData.identifier || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"identifier"
								);
								}}
							/>
							<span id="error-style">{this.state.identifierError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">SIC Code</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								onKeyPress={$event => onlyNumeric($event)}
								value={state.EditSettlementRateData.sicCode || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"sicCode"
								);
								}}
							/>
							<span id="error-style">{this.state.sicCodeError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Market</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditSettlementRateData.market || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"market"
								);
								}}
							/>
							<span id="error-style">{this.state.marketError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Case File</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditSettlementRateData.caseFile || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"caseFile"
								);
								}}
							/>
							<span id="error-style">{this.state.caseFileError}</span>
							</td>
						</tr>
						<tr>
							<td className="modalTd">Notes:</td>
							<td style={{ paddingTop: 16 }}>
							<input
								type="text"
								className="searchBox2"
								value={state.EditSettlementRateData.notes || ""}
								placeholder=""
								onChange={evt => {
								this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"notes"
								);
								}}
							/>
							<span id="error-style">{this.state.notesError}</span>
							</td>
						</tr>
						{state.enableSettlementRate ? (
							<tr>
							<td className="modalTd">Status</td>
							<td
								style={{ paddingTop: 16, zIndex: 1 }}
								className="relativePos"
							>
								<select
								style={{ width: "100%" }}
								className="statusSelect"
								value={state.EditSettlementRateData.status || ""}
								onChange={evt => {
									this.handleOnChange(
									state.EditSettlementRateData,
									evt.target.value,
									"status"
									);
								}}
								>
								<option value="SUBMITTED">SUBMITTED</option>
								<option value="REJECTED">REJECTED</option>
								<option value="PROCESSING">PROCESSING</option>
								<option value="COMPLETED">COMPLETED</option>
								</select>
							</td>
							</tr>
						) : null}
						
						<tr>
							<td className="modalTd">Industry Index </td>
							<td
							style={{ paddingTop: 16, zIndex: 1, width: "60%", color: "black"  }}
							className="relativePos"
							>
							<Select
								style={{ width: "100%", zIndex: 100, color: "black"  }}
								width="100%"
								name="indexListId"
								defaultValue={state.indexList[this.setSelectDefault(state.EditSettlementRateData.indexListId)]}
								onChange={this.handleSelectChange}
								options={state.indexList}

							/> 
							 <span id="error-style">{this.state.indexListIdError}</span>
							</td>
						</tr>
						</tbody>
					</table>
					<div className="btnHolder">
						<br />
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleSaveSettlementRate(state.EditSettlementRateData);
						}}
						>
						Save
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ open: false, EditSettlementRateData: {} });
							this.resetErrorStat();
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>
				<Modal open={this.state.fileUploadOpen} onClose={this.onCloseUploadModal}>
					<div className="ModalWindow modaladd">
						<FaTimes className="closeicon" onClick={this.onCloseUploadModal} />
						<h3 className="modalHeading">Upload Risk File</h3>
						<div className="NavDivider"></div>
						<table>
							<thead></thead>
							<tbody>
							<tr>
								<td className="modalTd">
								Risk Name:
								</td>
								<td style={{ paddingTop: 16 }}>
								<input
									id="companyName"
									type="text"
									className="searchBox2"
									value={state.EditSettlementRateFile.companyName || ""}
									readOnly
									
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Risk Assessment Date</td>
								<td style={{ paddingTop: 16 }}>
								<input
									className="searchBox2"
									value={state.EditSettlementRateFile.riskAssessmentDate_UI || ""}
									readOnly
									
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Ticker</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="text"
									className="searchBox2"
									onKeyPress={$event => allowAlphaNumeric($event)}
									value={state.EditSettlementRateFile.ticker || ""}
									readOnly
								/>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Upload File (xlsx)</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="file"
									name="excelFile"
									className="searchBox2 btn btnC"
									onChange={evt => {
									this.handleOnFileChange(
										evt
									);
									}}
								/>
								<span id="error-style" style={{color: "white"}}>{this.state.selectedExcelFileName?this.state.selectedExcelFileName:""}</span>
								</td>
							</tr>
							<tr>
								<td className="modalTd">Upload File (pdf)</td>
								<td style={{ paddingTop: 16 }}>
								<input
									type="file"
									name="pdfFile"
									className="searchBox2 btn btnC"
									onChange={evt => {
									this.handleOnFileChange(
										evt
									);
									}}
									
								/>
								<span id="error-style" style={{color: "white"}}>{this.state.selectedPdfFileName?this.state.selectedPdfFileName:""}</span>
								</td>
							</tr>
							
							{state.enableSettlementRate ? (
								<tr>
								<td className="modalTd">Status</td>
								<td
									style={{ paddingTop: 16, zIndex: 1 }}
									className="relativePos"
								>
									<select
									style={{ width: "100%" }}
									className="statusSelect"
									value={state.EditSettlementRateFile.status || ""}
									onChange={evt => {
										this.handleSettlementRateStatusOnChange(
										state.EditSettlementRateFile,
										evt.target.value,
										"status"
										);
									}}
									>
									<option value="SUBMITTED">SUBMITTED</option>
									<option value="REJECTED">REJECTED</option>
									<option value="PROCESSING">PROCESSING</option>
									<option value="COMPLETED">COMPLETED</option>
									</select>
								</td>
								</tr>
							) : null}
							</tbody>
						</table>
						<div className="btnHolder">
							<br />
							<button
							className="btn btnS"
							onClick={evt => {
								this.handleOnFileUpload(state.EditSettlementRateFile);
							}}
							>
							Upload
							</button>
							&nbsp; &nbsp;
							<button
							className="btn btnC"
							onClick={evt => {
								this.setState({ fileUploadOpen: false, EditSettlementRateFile: {} });
								this.resetErrorStat();
							}}
							>
							Cancel
							</button>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.openDelete}
					onClose={this.onCloseModal}
					className="deltemodal"
				>
					<div>
					<FaTimes className="deleteicon" onClick={this.onCloseModal} />
					</div>
					<div className="ModalWindow ModalDelete">
					<p style={{ textAlign: "center" }}>
						Are you sure you want to delete 
						 {" "+state.deleteModalData.companyName}?
					</p>
					<div className="textCenter">
						<button
						className="btn btnS"
						onClick={evt => {
							this.handleDelete(state.deleteModalData);
						}}
						>
						Delete
						</button>
						&nbsp; &nbsp;
						<button
						className="btn btnC"
						onClick={evt => {
							this.setState({ openDelete: false, deleteModalData: {} });
						}}
						>
						Cancel
						</button>
					</div>
					</div>
				</Modal>
				<Modal
					open={this.state.viewerModal}
					onClose={this.onCloseViewerModal}
					className="viewermodal"
				>
					<div>
					<FaTimes className="closeicon"  onClick={this.onCloseViewerModal} />
					</div>
					<div className="ModalWindow modaladd">
					
						<iframe 
							title="PreviewFile"
							width="600"
							height="400"
							scrolling="auto"
							src={this.state.viewerFileUrl}
							/>
					</div>
				</Modal>
				{/* //	SettlementRateInfo model start */}
				<Modal
					open={this.state.SettlementRateInfo}
					onClose={this.onCloseSettlementRateInfoModal}
					focusTrapped={true}
				>
					<div className="ModalWindow modaladd">
					<FaTimes
						className="closeicon"
						onClick={this.onCloseSettlementRateInfoModal}
					/>
					<h3 className="modalHeading">Risk Information</h3>
					<div className="NavDivider"></div>
					<DisclosureModal
						type="DisclosureReadonly"
						createFormState={this.state.currentSettlementRate}
					/>
					<div>
						<div className="NavDivider"></div>
					</div>
					</div>
				</Modal>
				{/* //	SettlementRateInfo model end */}

				<table className={"CaseSelectorTable"}>
					<thead>
					<tr className={"CaseSelectorHeaders"}>
						<th
						className={"CaseSelectorHeader"}
						style={{
							align: "left",
							justifyContent: "space-between",
							textAlign: "left",
							paddingTop: "16px"
						}}
						>
						Firm Name
						<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
							<div>
								<FaChevronUp
								className={
									props.sortValue === "firmName" &&
									props.sortOrder === "asc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("firmName", "asc")}
								/>
							</div>
							<div>
								<FaChevronDown
								className={
									props.sortValue === "firmName" &&
									props.sortOrder === "desc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("firmName", "desc")}
								/>
							</div>
							</div>
						</span>
						</th>
						<th
						className={"CaseSelectorHeader"}
						>
						{state.enableSettlementRate ? "Company" : "Filing"} Name
						<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
							<div>
								<FaChevronUp
								className={
									props.sortValue === "caseName" &&
									props.sortOrder === "asc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("caseName", "asc")}
								/>
							</div>
							<div>
								<FaChevronDown
								className={
									props.sortValue === "caseName" &&
									props.sortOrder === "desc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("caseName", "desc")}
								/>
							</div>
							</div>
						</span>
						</th>
						<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between"}}
						>
						Ticker
						<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
							<div>
								<FaChevronUp
								className={
									props.sortValue === "symbol" &&
									props.sortOrder === "asc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("symbol", "asc")}
								/>
							</div>
							<div>
								<FaChevronDown
								className={
									props.sortValue === "symbol" &&
									props.sortOrder === "desc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() => props.handleSorting("symbol", "desc")}
								/>
							</div>
							</div>
						</span>
						</th>
						<th
						className={"CaseSelectorHeader"}
						style={{ justifyContent: "space-between"}}
						>
						Risk Assess. <br />Date
						<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
							<div>
								<FaChevronUp
								className={
									props.sortValue === "riskAssessmentDate" &&
									props.sortOrder === "asc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() =>
									props.handleSorting("riskAssessmentDate", "asc")
								}
								/>
							</div>
							<div>
								<FaChevronDown
								className={
									props.sortValue === "riskAssessmentDate" &&
									props.sortOrder === "desc"
									? "activeSortBtn"
									: "sortBtn"
								}
								onClick={() =>
									props.handleSorting("riskAssessmentDate", "desc")
								}
								/>
							</div>
							</div>
						</span>
						</th>
						
						
						{state.enableSettlementRate && (
						<th
							className={"CaseSelectorHeader"}
							style={{ justifyContent: "space-between"}}
						>
							Date Added
							<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									props.sortValue === "dateAdded" &&
										props.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() =>
									props.handleSorting("dateAdded", "asc")
									}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									props.sortValue === "dateAdded" &&
										props.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() =>
									props.handleSorting("dateAdded", "desc")
									}
								/>
								</div>
							</div>
							</span>
						</th>
						)}
						
						
						
						{this.state.enableSettlementRate && (
						<th
							className={"CaseSelectorHeader"}
							style={{ justifyContent: "space-between"}}
						>
							Status
							<span style={{ position: "relative", left: "10px" }}>
							<div className={"sortingIconsHolder"}>
								<div>
								<FaChevronUp
									className={
									props.sortValue === "status" &&
										props.sortOrder === "asc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => props.handleSorting("status", "asc")}
								/>
								</div>
								<div>
								<FaChevronDown
									className={
									props.sortValue === "status" &&
										props.sortOrder === "desc"
										? "activeSortBtn"
										: "sortBtn"
									}
									onClick={() => props.handleSorting("status", "desc")}
								/>
								</div>
							</div>
							</span>
						</th>
						)}
						{this.state.isAdminToken === true &&
						this.state.enableView === false && (
							<th
							className={"CaseSelectorHeader"}
							style={{
								justifyContent: "space-between",
								width: this.state.enableSettlementRate ? "24%" : "16%"

							}}
							>
							Options
							</th>
						)}
					</tr>
					</thead>
					<tbody>
					{state.settlementRateDataArray.map((filledCase, index) => (

						<React.Fragment key={index}>
						{this.state.isAdminToken === true ? (

							<tr key={filledCase.settlementRateId}>
							<td className={state.className + "Admin"} style={{ float: "left", textAlign: "left", width: "80%" }}>
								{filledCase.firmId.substr(1)}
							</td>
							<td
								className={
								state.className +
								"Admin" +
								(state.routeName === "/CaseManagement" ||
									state.routeName === "/cases" ||
									state.routeName === "/CustomCaseManagement" ||
									state.routeName === "/SettlementRateManagement"
									? " cursorPointer"
									: " ")
								}
								onClick={() => this.goToCases(filledCase.settlementRateId)}
								
							>
								{filledCase.companyName}
							</td>
							<td className={state.className + "Admin"}>
								{filledCase.ticker}
							</td>
							<td className={state.className + "Admin"}>
								{filledCase.riskAssessmentDate_UI}
							</td>
							<td className={state.className + "Admin"}>
								{filledCase.dateAdded[0].toString().padStart(2, '0')+"-"+filledCase.dateAdded[1].toString().padStart(2, '0')+"-"+filledCase.dateAdded[2].toString().padStart(2, '0')}
							</td>
							
							{this.state.enableSettlementRate && (
								<td className={state.className + "Admin"}>
								{filledCase.status}
								</td>
							)}
							{this.state.enableView === false && (
								<td className={state.className + "Admin"} style={{ float: "left", textAlign: "left"}}>
								<label className="switch-container">
									<input
									ref="switch"
									value={filledCase.enabled}
									checked={filledCase.enabled}
									onChange={evt => {
										this.handleEnable(
										filledCase,
										evt.target.value,
										"enabled"
										);
									}}
									className="switch"
									type="checkbox"
									/>
									<div>
									<div></div>
									</div>
								</label>

								<FaEdit
									className="editBtn"
									onClick={() => this.handleEdit(filledCase)}
								/>

								<FaTrash
									className="editBtn"
									onClick={() => {
									this.setState({
										openDelete: true,
										deleteModalData: filledCase
									});
									}}
								/>
								{this.state.enableSettlementRate && (
									<FaInfoCircle
									className="editBtn"
									onClick={() =>
										this.handleInfo(filledCase)
									}
									/>
								)}
								<FaUpload
									className="editBtn"
									onClick={() => this.handleFileUpload(filledCase)}
								/>

								{filledCase.pdfURL.length > 0 && (<FaFilePdf
									className="editBtn"
									onClick={() => this.handleViewer(filledCase.pdfURL, 'pdf')}
								/>)}
								{filledCase.excelURL.length > 0 && (<FaFileExcel
									className="editBtn"
									onClick={() => this.handleViewer(filledCase.excelURL, 'xlsx')}
								/>)}
								
								</td>
							)}
							</tr>
						) : this.state.isAdminToken === false &&
							props.firmSettings &&
							props.firmSettings.SettlementRateEnabled === true &&
							props.firmSettings.subscription === true ? (
								<tr>
								<td
									className={state.className}
									style={{ float: "left", textAlign: "left", width: "80%" }}
								>
									{filledCase.companyName}
								</td>
								<td className={state.className}>
									{filledCase.riskAssessmentDate_UI}
								</td>
								<td className={state.className}>{filledCase.ticker}</td>
								</tr>
							) : (
								<tr>
								<td
									className={state.className + "User"}
									style={{ float: "left", textAlign: "left", width: "80%" }}
								>
									{filledCase.companyName}
								</td>
								<td className={state.className + "User"}>
									{filledCase.riskAssessmentDate_UI}
								</td>
								<td className={state.className + "User"}>
									{filledCase.ticker}
								</td>
								</tr>
							)}
						</React.Fragment>
					))}
					</tbody>
				</table>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentSettlementRates: state.settlementRates.currentSettlementRates,
		currentPage: state.settlementRates.currentPage,
		totalSettlementRates: state.settlementRates.totalSettlementRates,
		totalPages: state.settlementRates.totalPages,
		firmSettings: state.firmSettings,
		SettlementRateInfo: state.settlementRates.SettlementRateInfo
	};
};
const mapDispatchToProps = dispatch => {
	return {
		fetch_settlementRates: (page, sortValue, sortOrder) =>
			dispatch(fetch_settlementRates(page, sortValue, sortOrder)),
		editInput: SettlementRateData => {
			dispatch({ type: "LOAD_UPDATED_DANDOS", value: SettlementRateData });
		},
		fetch_settlementRate: id => dispatch(fetch_settlementRate(id))
	};
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SettlementRateEntries));



// WEBPACK FOOTER //
// ./src/components/SettlementRate/SettlementRateEntries.js